import Diacritic from './-formatters/diacritics'
const diacritic = Diacritic()
export { diacritic }
export default defineNuxtPlugin(() => {
  return {
    provide: {
      diacritic
    }
  }
})
